import axios from "axios";
const backend = process.env.REACT_APP_BACKEND;

const phoneticFuntions = {
  phoneticErrorChange: (text) => {
    let changeText = text;
    if (changeText.indexOf("&#240") !== -1) {
      changeText = changeText.replaceAll("&#240", "ð");
    }
    if (changeText.indexOf("&#230") !== -1) {
      changeText = changeText.replaceAll("&#230", "æ");
    }
    if (changeText.indexOf(";") !== -1) {
      changeText = changeText.replaceAll(";", "");
    }
    if (changeText.indexOf("!") !== -1) {
      changeText = changeText.replaceAll("!", "");
    }
    if (changeText.indexOf("?") !== -1) {
      changeText = changeText.replaceAll("?", "");
    }
    if (changeText.indexOf("ˈaɪz") === 0) {
      changeText = changeText.replace("ˈaɪz", "ɪz");
    }
    if (changeText.indexOf("aɪz") === 0) {
      changeText = changeText.replace("aɪz", "ɪz");
    }
    return changeText;
  },

  dotChange: async (text) => {
    let changedText = text.replace(".", "") + "..";
    if (
      (changedText[0] === "i" || changedText[0] === "I") &&
      changedText[1] === "s" &&
      changedText[2] === " "
    ) {
      changedText = "a" + changedText;
    }
    return changedText;
  },

  getPhonetic: async (text) => {
    const phoneticResult = await axios.post(
      `${backend}/contents/content_sentence/sentence/phonetic`,
      { text },
      {
        withCredentials: true,
      }
    );
    return phoneticResult;
  },
  compareData: (a, b) => {
    const a_ = Object.keys(a);
    const b_ = Object.keys(b);

    if (a_.length !== b_.length) return false;
    for (let key of a_) {
      if (key === "sentenceStatus") continue
      if (a[key] !== b[key]) {
        // 어느 부분이 틀린 것인지 알고 싶을 때 사용하는 코드
        // console.log(key)
        // for(let n=0; n<a[key].length; n++) {
        //   if(a[key][n] !== b[key][n]) {
        //     console.log(a[key][n]+"와"+ b[key][n])
        //   }
        // }
        return false;
      }
    }
    return true;
  },
  compareData2: (a) => {
    if(a.seq !== a.seq_origin) return false
    if(a.sentence_text !== a.sentence_text_origin) return false
    if(a.roman_sentence_text !== a.roman_sentence_text_origin) return false
    if(a.ContentSettingTense_code !== a.ContentSettingTense_code_origin) return false
    if(a.ContentSettingSentencePattern_code !== a.ContentSettingSentencePattern_code_origin) return false
    if(a.dependent_clause_yn !== a.dependent_clause_yn_origin) return false
    if(a.sentence_subject !== a.sentence_subject_origin) return false
    if(a.sentence_verb !== a.sentence_verb_origin) return false
    if(a.sentence_direct_object !== a.sentence_direct_object_origin) return false
    if(a.sentence_indirect_object !== a.sentence_indirect_object_origin) return false
    if(a.sentence_complement !== a.sentence_complement_origin) return false
    if(a.sentence_adverb !== a.sentence_adverb_origin) return false
    if(a.sentence_etc !== a.sentence_etc_origin) return false
    if(a.sentence_voice_filename !== a.sentence_voice_filename_origin) return false
    if(a.learning_sentence_elements_yn !== a.learning_sentence_elements_yn_origin) return false
    if(a.learning_vocabulary_yn !== a.learning_vocabulary_yn_origin) return false
    if(a.vocabulary_text !== a.vocabulary_text_origin) return false
    if(a.error_status) return false
    return true
  },
};

export default phoneticFuntions;
